type LogLevel = "info" | "warn" | "error";

interface LogEntry {
  level: LogLevel;
  msg: string;
  ts: string;
  [key: string]: unknown;
}

function emit(level: LogLevel, msg: string, data?: Record<string, unknown>) {
  const entry: LogEntry = { level, msg, ts: new Date().toISOString(), ...data };
  const fn = level === "error" ? console.error : level === "warn" ? console.warn : console.log;
  if (typeof window === "undefined") {
    fn(JSON.stringify(entry));
  } else {
    fn(`[${level}] ${msg}`, data ?? "");
  }
}

export const logger = {
  info: (msg: string, data?: Record<string, unknown>) => emit("info", msg, data),
  warn: (msg: string, data?: Record<string, unknown>) => emit("warn", msg, data),
  error: (msg: string, data?: Record<string, unknown>) => emit("error", msg, data),
};
